export const recycleBinArticles = [
    {
        id: 'recycle-bin.overview',
        title: 'Recycle Bin Overview',
        category: 'Recycle Bin',
        order: 1,
        summary: 'Managing deleted items and recovery',
        content: `
The Recycle Bin holds deleted items before they are permanently removed. Items can be restored or permanently deleted from here.

**What Goes to Recycle Bin:**

- Deleted jobs
- Deleted BOQ items
- Deleted orders
- Deleted documents
- Other deleted records

**Retention Period:**

Deleted items are kept for 30 days by default before automatic permanent deletion.
    `,
        expandableSections: [
            {
                title: 'Recycle Bin Grid',
                content: `
The grid shows deleted items with:

- **Name/Description** - What was deleted
- **Type** - Item type (Job, Document, etc.)
- **Deleted** - When it was deleted
- **Deleted By** - Who deleted it
- **Expires** - When it will be permanently removed

Filter by type to find specific items.
        `,
            },
        ],
        keywords: ['recycle bin', 'trash', 'deleted', 'recover'],
        route: '/recycle-bin',
        relatedArticles: ['recycle-bin.restore', 'recycle-bin.delete'],
    },
    {
        id: 'recycle-bin.restore',
        title: 'Restoring Items',
        category: 'Recycle Bin',
        order: 2,
        summary: 'How to restore deleted items',
        content: `
Restore items from the Recycle Bin to return them to their original location.

**Restore Process:**

1. Find the item in the Recycle Bin
2. Select it
3. Click Restore
4. Item returns to its original location
    `,
        expandableSections: [
            {
                title: 'Restoring Items',
                content: `
**Single Item:**
1. Find and select the item
2. Click **Restore** button
3. Or right-click > Restore
4. Item is restored

**Multiple Items:**
1. Select multiple items (Ctrl+Click)
2. Click **Restore Selected**
3. All items are restored

**Restore Location:**
Items restore to their original location. If the parent was also deleted, you may need to restore it first.
        `,
            },
            {
                title: 'Restore Limitations',
                content: `
Some items may not restore if:

- Parent item no longer exists
- Referenced items are missing
- Unique constraints conflict

In these cases, you'll see an error message explaining the issue.
        `,
            },
        ],
        keywords: ['restore', 'recover', 'undelete', 'bring back'],
        route: '/recycle-bin',
        relatedArticles: ['recycle-bin.overview'],
    },
    {
        id: 'recycle-bin.delete',
        title: 'Permanent Deletion',
        category: 'Recycle Bin',
        order: 3,
        summary: 'Permanently deleting items',
        content: `
Permanently delete items to remove them completely from the system. This action cannot be undone.

**Warning:** Permanent deletion is irreversible. Data cannot be recovered after permanent deletion.
    `,
        expandableSections: [
            {
                title: 'Permanent Delete Process',
                content: `
1. Select items to permanently delete
2. Click **Delete Permanently**
3. Confirm the action
4. Items are removed forever

**Empty Recycle Bin:**
1. Click **Empty Recycle Bin**
2. Confirm the action
3. All items are permanently deleted

This removes everything currently in the Recycle Bin.
        `,
            },
        ],
        keywords: ['permanent delete', 'remove', 'destroy', 'empty'],
        route: '/recycle-bin',
        relatedArticles: ['recycle-bin.overview', 'recycle-bin.restore'],
    },
];
